import { GoalStats } from '../../typings/goals';
import { showConditionsRowFragment_GdRelevanceMatch_goalStats } from '../../typings/graphql-grid';

export function mapRowGoals(
    rowGoalStats: showConditionsRowFragment_GdRelevanceMatch_goalStats[]
): Record<string, GoalStats> {
    return rowGoalStats.reduce((acc, goalStat) => {
        acc[goalStat.goalId] = goalStat;
        return acc;
    }, {});
}
